import { RawTrader } from './types';

export const RAW_TRADERS: RawTrader[] = [
  {
    name: 'Nguyễn Văn A',
    role: 'Capital Manager',
    country: 'VN',
    stage: 'Funded',
    cap: 400000,
    demo: 10000,
    ret: 14.8,
    wr: 63,
    pf: 1.72,
    dd: 4.8,
    curDd: 1.2,
    risk: 92,
    score: 91,
    days: 187,
    since: '03/2026',
    tone: 'good',
    status: 'Ổn định',
    tags: ['Forex', 'XAUUSD', 'Swing'],
    long: 58,
    viol: 0,
    load: 34,
    ins: [
      'Ổn định và kỷ luật',
      'Lợi nhuận đều qua 10/12 tháng, drawdown sâu nhất 4.8% và rủi ro trung bình mỗi lệnh 0.48%. Không có lần vi phạm giới hạn nào trong 187 ngày giao dịch.',
    ],
    scores: [94, 92, 88, 96, 86],
    mentor: [
      'Nguyễn Tiến Bảo',
      '18/09/2026',
      'Kỷ luật rủi ro tốt, khối lượng ổn định qua các giai đoạn. Cần giảm số lệnh không cần thiết trong phiên Á và giữ nguyên kế hoạch vào lệnh.',
    ],
    platform: 'mt4',
    accounts: [
      ['Funded', '2 tài khoản · $100,000 + $200,000', 300000, 16.2],
      ['Verification', '1 tài khoản · đã hoàn thành', 100000, 10.4],
      ['Challenge', '1 tài khoản · đã hoàn thành', 100000, 12.1],
      ['Demo', 'Không tính vào số liệu tổng hợp', 10000, 22.5],
    ],
  },
  {
    name: 'Trần Minh Quân',
    role: 'Capital Manager',
    country: 'VN',
    stage: 'Funded',
    cap: 200000,
    demo: 25000,
    ret: 22.6,
    wr: 51,
    pf: 1.55,
    dd: 11.4,
    curDd: 6.8,
    risk: 64,
    score: 78,
    days: 142,
    since: '04/2026',
    tone: 'warn',
    status: 'Rủi ro cao hơn',
    tags: ['XAUUSD', 'Intraday', 'News'],
    long: 47,
    viol: 2,
    load: 78,
    ins: [
      'Lợi nhuận cao, rủi ro cao hơn',
      'Lợi nhuận dẫn đầu nhóm nhưng drawdown 11.4% và 2 lần chạm giới hạn lỗ ngày. Rủi ro mỗi lệnh 1.34%, cao gần 3 lần mức trung bình của nhóm Funded.',
    ],
    scores: [96, 58, 74, 80, 68],
    mentor: [
      'Nguyễn Tiến Bảo',
      '12/09/2026',
      'Khả năng đọc thị trường tốt nhưng khối lượng chưa nhất quán. Ưu tiên cố định rủi ro mỗi lệnh trước khi xét nâng vốn.',
    ],
    platform: 'mt4',
    accounts: [
      ['Funded', '1 tài khoản · $200,000', 200000, 22.6],
      ['Verification', '1 tài khoản · đã hoàn thành', 100000, 14.8],
      ['Demo', 'Không tính vào số liệu tổng hợp', 25000, 41.2],
    ],
  },
  {
    name: 'Đỗ Khánh Vy',
    role: 'Capital Manager',
    country: 'VN',
    stage: 'Verification',
    cap: 100000,
    demo: 10000,
    ret: 11.9,
    wr: 59,
    pf: 1.68,
    dd: 5.2,
    curDd: 2.1,
    risk: 88,
    score: 83,
    days: 118,
    since: '05/2026',
    tone: 'good',
    status: 'Ổn định',
    tags: ['Forex', 'Indices', 'Swing'],
    long: 55,
    viol: 0,
    load: 41,
    ins: [
      'Ổn định',
      'Lợi nhuận 11.9% với drawdown 5.2% và không có vi phạm giới hạn. 9/12 tháng dương, khối lượng giữ đều qua các giai đoạn.',
    ],
    scores: [86, 88, 84, 90, 80],
    mentor: ['Nguyễn Tiến Bảo', '16/09/2026', 'Tiến độ tốt, đủ điều kiện xét nâng lên Funded trong chu kỳ tới.'],
    platform: 'mt4',
    accounts: [
      ['Verification', '1 tài khoản · $100,000', 100000, 11.9],
      ['Challenge', '1 tài khoản · đã hoàn thành', 100000, 13.4],
      ['Demo', 'Không tính vào số liệu tổng hợp', 10000, 19.6],
    ],
  },
  {
    name: 'Bùi Thanh Hà',
    role: 'Capital Manager',
    country: 'VN',
    stage: 'Funded',
    cap: 200000,
    demo: 10000,
    ret: 9.4,
    wr: 57,
    pf: 1.61,
    dd: 6.1,
    curDd: 2.8,
    risk: 85,
    score: 81,
    days: 154,
    since: '04/2026',
    tone: 'good',
    status: 'Ổn định',
    tags: ['Forex', 'Swing'],
    long: 61,
    viol: 0,
    load: 46,
    ins: [
      'Ổn định',
      'Profit factor 1.61 và drawdown 6.1% qua 154 ngày giao dịch. Không có vi phạm giới hạn, khối lượng tăng theo lộ trình.',
    ],
    scores: [80, 86, 82, 88, 78],
    mentor: [
      'Nguyễn Tiến Bảo',
      '14/09/2026',
      'Hồ sơ cân bằng. Có thể mở rộng số symbol theo dõi nhưng giữ nguyên rủi ro mỗi lệnh.',
    ],
    platform: 'mt4',
    accounts: [
      ['Funded', '1 tài khoản · $200,000', 200000, 9.4],
      ['Verification', '1 tài khoản · đã hoàn thành', 100000, 12.2],
      ['Demo', 'Không tính vào số liệu tổng hợp', 10000, 14.1],
    ],
  },
  {
    name: 'Lê Thị Hạnh',
    role: 'Capital Manager',
    country: 'VN',
    stage: 'Verification',
    cap: 100000,
    demo: 10000,
    ret: 8.2,
    wr: 68,
    pf: 1.94,
    dd: 3.1,
    curDd: 0.4,
    risk: 95,
    score: 86,
    days: 96,
    since: '06/2026',
    tone: 'good',
    status: 'Rủi ro thấp',
    tags: ['Forex', 'Swing'],
    long: 62,
    viol: 0,
    load: 27,
    ins: [
      'Rủi ro thấp, lợi nhuận vừa phải',
      'Profit factor 1.94 với drawdown chỉ 3.1%. Lợi nhuận thấp hơn nhóm nhưng đạt được với mức rủi ro thấp nhất trong bảng xếp hạng.',
    ],
    scores: [82, 96, 90, 94, 88],
    mentor: [
      'Nguyễn Tiến Bảo',
      '15/09/2026',
      'Hồ sơ rủi ro rất tốt. Có thể tăng nhẹ khối lượng theo lộ trình khi vào giai đoạn Funded.',
    ],
    platform: 'ctrader',
    accounts: [
      ['Verification', '1 tài khoản · $100,000', 100000, 8.2],
      ['Challenge', '1 tài khoản · đã hoàn thành', 100000, 9.6],
      ['Demo', 'Không tính vào số liệu tổng hợp', 10000, 15.1],
    ],
  },
  {
    name: 'Hoàng Nhật Minh',
    role: 'Trader',
    country: 'VN',
    stage: 'Challenge',
    cap: 50000,
    demo: 10000,
    ret: 16.2,
    wr: 54,
    pf: 1.44,
    dd: 6.8,
    curDd: 3.1,
    risk: 76,
    score: 74,
    days: 72,
    since: '06/2026',
    tone: 'warn',
    status: 'Dữ liệu chưa đủ dài',
    tags: ['XAUUSD', 'Intraday'],
    long: 49,
    viol: 0,
    load: 58,
    ins: [
      'Dữ liệu chưa đủ để đánh giá',
      '72 ngày giao dịch, chưa đạt mốc 90 ngày tối thiểu để đánh giá tính ổn định. Lợi nhuận tốt nhưng phần lớn đến từ tháng gần nhất.',
    ],
    scores: [88, 72, 58, 84, 66],
    mentor: [
      'Nguyễn Tiến Bảo',
      '10/09/2026',
      'Đang trong Challenge. Cần thêm dữ liệu và giữ rủi ro dưới 1% mỗi lệnh.',
    ],
    platform: 'ctrader',
    accounts: [
      ['Challenge', '1 tài khoản · $50,000', 50000, 16.2],
      ['Demo', 'Không tính vào số liệu tổng hợp', 10000, 24.3],
    ],
  },
  {
    name: 'Phạm Đức Long',
    role: 'Trader',
    country: 'VN',
    stage: 'Challenge',
    cap: 100000,
    demo: 10000,
    ret: 5.4,
    wr: 44,
    pf: 1.21,
    dd: 7.9,
    curDd: 3.6,
    risk: 71,
    score: 68,
    days: 58,
    since: '07/2026',
    tone: 'warn',
    status: 'Dữ liệu chưa đủ dài',
    tags: ['XAUUSD', 'Intraday'],
    long: 51,
    viol: 1,
    load: 63,
    ins: [
      'Dữ liệu chưa đủ để đánh giá',
      'Chỉ 58 ngày giao dịch và 1 lần chạm giới hạn lỗ ngày. Profit factor 1.21 chưa đủ khoảng đệm để kết luận về tính ổn định.',
    ],
    scores: [70, 68, 52, 82, 60],
    mentor: [
      'Nguyễn Tiến Bảo',
      '08/09/2026',
      'Đang trong Challenge. Cần thêm ít nhất 60 ngày giao dịch trước khi đánh giá tính ổn định.',
    ],
    platform: 'mt5',
    accounts: [
      ['Challenge', '1 tài khoản · $100,000', 100000, 5.4],
      ['Demo', 'Không tính vào số liệu tổng hợp', 10000, 8.8],
    ],
  },
  {
    name: 'Vũ Hải Đăng',
    role: 'Capital Manager',
    country: 'VN',
    stage: 'Funded',
    cap: 300000,
    demo: 10000,
    ret: -2.4,
    wr: 47,
    pf: 0.92,
    dd: 13.6,
    curDd: 11.9,
    risk: 41,
    score: 52,
    days: 164,
    since: '02/2026',
    tone: 'bad',
    status: 'Cảnh báo rủi ro',
    tags: ['XAUUSD', 'Scalping'],
    long: 44,
    viol: 4,
    load: 94,
    ins: [
      'Cảnh báo rủi ro',
      'Drawdown hiện tại 11.9% đang ở gần mức sâu nhất lịch sử và profit factor đã xuống dưới 1. Bốn lần chạm giới hạn lỗ ngày trong 90 ngày gần nhất.',
    ],
    scores: [44, 36, 48, 62, 40],
    mentor: [
      'Nguyễn Tiến Bảo',
      '19/09/2026',
      'Đã yêu cầu giảm khối lượng 50% và tạm dừng giao dịch tin. Đang trong giai đoạn theo dõi.',
    ],
    platform: 'mt5',
    accounts: [
      ['Funded', '1 tài khoản · $300,000', 300000, -2.4],
      ['Verification', '1 tài khoản · đã hoàn thành', 100000, 11.2],
      ['Demo', 'Không tính vào số liệu tổng hợp', 10000, -6.4],
    ],
  },
];
